export default __webpack_public_path__ + "static/media/NEUSTAR.8de38cc1.png";